<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Aviso de Privacidad</li>
      </template>
      <template slot="title">
        Aviso de Privacidad
      </template>
      <template slot="body">
        <PrivacyContract />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import PrivacyContract from "@components/contracts/PrivacyContract/PrivacyContract-05-2022.vue";
import GenericPage from "./new-portal-views/GenericPage.vue"
export default {
  name: "PrivacyContractPage",
  components: {
    PrivacyContract,
    GenericPage
  }
}
</script>

<style scoped>

</style>